import { CustomErrorForSentry } from '@/utils/customErrorForSentry';

export const STRUCTURE_ID_MISSING_ERROR = new CustomErrorForSentry({
  message: 'Failed to get structure ID',
});

export const INSIGHTS_DATA_LOADER_LOCATION_ERROR = new CustomErrorForSentry({
  code: 'FABW-INS-0001',
  message: 'Failed to fetch location data',
});

export const INSIGHTS_DATA_LOADER_RISK_ASSESSMENT_ERROR = new CustomErrorForSentry({
  code: 'FABW-INS-0002',
  message: 'Failed to fetch risk assessment data',
});
export const INSIGHTS_EXPLORER_FETCH_SVG_ERROR = new CustomErrorForSentry({
  code: 'FABW-INS-0004',
  message: 'Failed to fetch SVGs data',
});

export const INSIGHTS_EXPLORER_FETCH_TEMPLATE_ERROR = new CustomErrorForSentry({
  code: 'FABW-INS-0005',
  message: 'Failed to fetch template data',
});

export const INSIGHTS_CREATE_ASSEMBLY_MUTATION_ERROR = new CustomErrorForSentry({
  code: 'FABW-INS-0006',
  message: 'Failed to create assembly',
});

export const INSIGHTS_USER_PREFERENCE_ERROR = new CustomErrorForSentry({
  code: 'FABW-INS-0008',
  message: 'Failed to fetch user preferences',
});

export const INSIGHTS_GET_FILTERED_ASSEMBLIES_ERROR = new CustomErrorForSentry({
  code: 'FABW-INS-0009',
  message: 'Failed to fetch filtered assemblies',
});

export const INSIGHTS_DECK_WITH_PAINT_REGIONS_ERROR = new CustomErrorForSentry({
  code: 'TEST-FABW-INS-0010',
  message: 'Failed to fetch decks with paint regions',
});
